export interface IIconProps {
	name?: string;
	color?: string;
	colorVariant?: number;
	fill?: boolean;
	fillstrokesame?: boolean;
	fillColor?: string;
	fillColorVariant?: number;
	hex?: string;
	viewBox?: string;
	size?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
	className?: string;
	isTwoToneIcon?: boolean;
	middleAlign?: boolean;
	onClick?(event: React.MouseEvent): void;
	isIllustration?: boolean;
}

export enum EIcons {
	ADMINPROFILE = "admin-profile",
	ADD = "add",
	ADDTOCOLLECTION = "add-to-collection",
	ADDPRODUCT = "add-product",
	ADDCIRCLE = "add-circle",
	AISTAR = "ai-star",
	AICOMPANYBRIEF = "ai-company-brief",
	AIAUTOCONFIG = "ai-auto-config",
	AIPARSING = "ai-parsing",
	AIASSISTANT = "ai-assistant",
	ALIGNBOTTOM = "align-bottom",
	ALIGNCENTER = "align-center",
	ALIGNTOP = "align-top",
	AMOUNT = "amount",
	ANGULARBRACKET = "angular-bracket",
	APPROVALRULES = "approval-rules",
	ARROWDOWN = "arrow-down",
	ARROWLEFT = "arrow-left",
	ARROWLEFTCURVESHARP = "arrow-left-curve-sharp",
	ARROWRIGHT = "arrow-right",
	ARROWUP = "arrow-up",
	ASSIGNED = "assigned",
	ATEXT = "a-text",
	ATEXTCOLOR = "a-text-color",
	ATTACHMENT = "attachment",
	AUDITLOGS = "audit-logs",
	BLOCK = "block",
	BOLDB = "bold-b",
	BOLDITALICUNDERLINE = "bold-italic-underline",
	BOLDT = "bold-t",
	BOLDUNDERLINE = "bold-underline",
	BOLD = "bold",
	BOOKMARKREMOVE = "bookmark-remove",
	BOOKMARKSLASH = "bookmark-slash",
	BOOKMARKTAG = "bookmark-tag",
	BOOKMARK = "bookmark",
	BOOKMARKS = "bookmarks",
	CALENDAR = "calendar",
	CALENDARADD = "calendar-add",
	CALENDARDELETE = "calendar-delete",
	CALENDARREMOVE = "calendar-remove",
	CALENDARSUCCESS = "calendar-success",
	CALENDARWARNING = "calendar-warning",
	CANCEL = "cancel",
	CAPSLOCKKEY = "caps-lock-key",
	CARD = "card",
	CHARTPIE = "chart-pie",
	CHART = "chart",
	CHECK = "check",
	CHECKCIRCLE = "check-circle",
	CHECKCIRCLESOLID = "check-circle-solid",
	CHEVRONDOUBLELEFT = "chevron-double-left",
	CHEVRONDOUBLERIGHT = "chevron-double-right",
	CHEVRONDOUBLEDOWN = "chevron-double-down",
	CHEVRONDOUBLEUP = "chevron-double-up",
	CHEVRONDOWN = "chevron-down",
	CHEVRONDOWNV2 = "chevron-down-v2",
	CHEVRONLEFT = "chevron-left",
	CHEVRONRIGHT = "chevron-right",
	CHEVRONUP = "chevron-up",
	CIRCLECHATDOT = "circle-chat-dot",
	CIRCLENOTIFICATION = "circle-notification",
	CIRCLETICK = "circle-tick",
	CIRCLEQUESTION = "circle-question",
	CIRCLETICKSOLID = "circle-tick-solid",
	CLEARTEXTFORMAT = "clear-text-format",
	CLONE = "clone",
	CLOSE = "close",
	CLOSECIRCLEFILLED = "close-circle-filled",
	CLOSECIRCLE = "close-circle",
	CLOUDASSESSMENT = "cloud-assessment",
	COMMENTSARCHIVE = "comments-archive",
	COINSTACK = "coin-stack",
	COLLECTPAYMENTS = "collect-payments",
	COLLECTPAYMENTSV2 = "collect-payments-v2",
	COLUMN = "column",
	COMPANY = "company",
	COPY = "copy",
	CUSTOMEFIELDS = "customfields",
	DASHEDLIST = "dashed-list",
	DATE = "date",
	DECREASEINDENT = "decrease-indent",
	DESCRIPTION = "description",
	DISPLAY = "display",
	DIVIDE = "divide",
	DOCASSESSMENT = "doc-assessment",
	DOCCONTRACT = "doc-contract",
	DOCPROPOSAL = "doc-proposal",
	DOCQBR = "doc-qbr",
	DOCQUOTE = "doc-quote",
	DOCORDERFORM = "doc-order-form",
	DOCUMENTAI = "document-ai",
	DOLLARSIGN = "dollar-sign",
	DOWNSQUARE = "down-square",
	DOWNLOADCLOUD = "download-cloud",
	DOWNLOAD = "download",
	DRAG = "drag",
	DRAGBLOCK = "drag-block",
	EMAILINBOX = "email-inbox",
	EMAILSETTING = "email-setting",
	EMAILTEMPLATE = "email-template",
	EMAILTHREAD = "email-thread",
	EMAILREPLY = "email-reply",
	ENLIGHT = "enlight",
	EXCLAMATIONCIRCLE = "exclamation-circle",
	EXTERNALLINK = "external-link",
	EYE = "eye",
	EYEOFF = "eye-off",
	FACEBOOK = "facebook",
	FACEBOOK2 = "facebook-2",
	FACEPLUS = "faceplus",
	FILE = "file",
	FILEADD = "file-add",
	FILEATTACHMENTUPLOADED = "file-attachment-uploaded",
	FILEDONE = "file-done",
	FILESEARCH = "file-search",
	FILTER = "filter",
	FILTERCIRCLESOLID = "filter-circle-solid",
	FLIPVERTICAL = "flip-vertical",
	FLIPHORIZONTAL = "flip-horizontal",
	FOCUS = "focus",
	FOLDER = "folder",
	FONTSIZE = "font-size",
	GIFT = "gift",
	GLOBAL = "global",
	GRAPH = "graph",
	GRIDVIEW = "grid-view",
	HASHTAG = "hashtag",
	HELP = "help",
	HORIZONTALCENTER = "horizontal-center",
	HORIZONTALLEFT = "horizontal-left",
	HORIZONTALRIGHT = "horizontal-right",
	HISTORY = "history",
	HIDETAX = "hide-tax",
	HOME = "home",
	IMAGEADD = "image-add",
	IMAGE = "image",
	IMAGEREMOVE = "image-remove",
	IMAGETICK = "image-tick",
	IMPORTPRODUCTTOQUOTE = "import-product-to-quote",
	INCREASEINDENT = "increase-indent",
	INFOCIRCLE = "info-circle",
	INPUTFIELD = "input-field",
	INTEGRATIONS = "integrations",
	ITALICT = "italic-t",
	ITALIC = "italic",
	JUSTIFIED = "justified",
	LINK = "link",
	LIST = "list",
	LOADING = "loading",
	LOGOUT = "logout",
	MAIL = "mail",
	MAILNOTIFICATION = "mail-notification",
	MAILSETTINGS = "mail-settings",
	MAILSUCCESS = "mail-success",
	MARKETPLACE = "marketplace",
	MAXIMIZE = "maximize",
	MEH = "meh-emoticon",
	MENUSQUARESSPACED = "menu-squares-spaced",
	MENUUNEQUAL = "menu-unequal",
	MENUDESCENDING = "menu-descending",
	MENUASCENDING = "menu-ascending",
	MENUSQUARES = "menu-squares",
	MENU = "menu",
	MISSIONCONTROL = "mission-control",
	MONEYBAG = "money-bag",
	MONEYBAG2 = "money-bag2",
	MOREVERTICAL = "more-vertical",
	MOVIE = "movie",
	NETWORK = "network",
	NEWFOLDER = "new-folder",
	NEWIMAGE = "new-image",
	NOTIFICATION = "notification",
	NUMBEREDLIST = "numbered-list",
	OPPORTUNITIES = "opportunities",
	PACKAGE = "package",
	PAGEBREAK = "page-break",
	PARTNERS = "partners",
	PAUSE = "pause",
	PEN = "pen",
	PENV2 = "penv2",
	PERCENT = "percent",
	PERCENTADDON = "percent-addon",
	PHONE = "phone",
	PIN = "pin",
	PIPELINES = "pipelines",
	PLAY = "play",
	PORTRAIT = "portrait",
	PRESENTATIONONBOARD = "presentation-on-board",
	PRESENTATIONLINEGRAPH = "presentation-line-graph",
	PRESENTATION = "presentation",
	PRESENTATIONSCREEN = "presentation-screen",
	PRINT = "print",
	PRODUCTS = "products",
	PURCHASEORDER = "purchase-order",
	RECEIPT = "receipt",
	REFRESH = "refresh",
	REMOVE = "remove",
	REMOVEPOINT = "remove-point",
	REMOVEFROMCOLLECTION = "remove-from-collection",
	REVISIONHISTORY = "revision-history",
	PENDING = "pending",
	REPLYEMAIL = "reply-email",
	RESEARCH = "research",
	RESEND = "resend",
	RESOURCES = "resources",
	ROCKET = "rocket",
	ROCKET2 = "rocket2",
	ROW = "row",
	SAVE = "save",
	SALESACTIVITY = "sales-activity",
	SCAN = "scan",
	SEARCH = "search",
	SENDBUTTONROUNDSLASH = "send-button-round-slash",
	SENDBUTTONROUND = "send-button-round",
	SENDBUTTONPLANE = "send-button-plane",
	SENDBUTTONHORIZONTAL = "send-button-horizontal",
	SENDBUTTONSLASH = "send-button-slash",
	SENDBUTTON = "send-button",
	SETPOINT = "set-point",
	SETTING = "setting",
	SHARE = "share",
	SHIFTKEY = "shift-key",
	SIGNATUREPEN = "signature-pen",
	SLIDERHORIZONTAL = "slider-horizontal",
	SLIDERVERTICAL = "slider-vertical",
	SOFTWARE = "software",
	SORTDOWN = "sort-down",
	SORTUP = "sort-up",
	SPARKLES = "sparkles",
	SPARKLESLEFT = "sparkles-left",
	SQUARECHATDOT = "square-chat-dot",
	STAR = "star",
	STARICON = "star-icon",
	STOP = "stop",
	STOPWATCH = "stopwatch",
	STRIKETHROUGHS = "strike-through-s",
	STRIKETHROUGHT = "strike-through-t",
	SHUFFLE = "shuffle",
	SYNC = "sync",
	TABLESMALLGRIDS = "table-small-grids",
	TABLE = "table",
	TAG = "tag",
	TAXSETUP = "taxsetup",
	TEXTBOX = "text-box",
	TEXTCURSOR = "text-cursor",
	TEXTCURSORT = "text-cursor-t",
	TEXTHEIGHT = "text-height",
	TEXTSIZEDECREASE = "text-size-decrease",
	TEXTSIZEINCREASE = "text-size-increase",
	TEXTSUBSCRIPT = "text-subscript",
	TEXTSUPERSCRIPT = "text-superscript",
	TEXTWEIGHT = "text-weight",
	TEXT = "text",
	TEXTCOLOR = "text-color",
	THUMBSUP = "thumbs-up",
	THUMBSDOWN = "thumbs-down",
	TRASH = "trash",
	TRASHV2 = "trashv2",
	TRIGGER = "trigger",
	TWITTER = "twitter",
	TWITTER2 = "twitter-2",
	UNDERLINEU = "underline-u",
	UNDERLINET = "underline-t",
	UPSQUARE = "up-square",
	UPLOAD = "upload",
	UPLOADV2 = "upload-v2",
	UPLOADCLOUD = "upload-cloud",
	UPLOADCLOUDV2 = "upload-cloud-v2",
	UPLOADCOMPLETE = "upload-complete",
	USER = "user",
	USERADDCIRCLE = "user-add-circle",
	USERCIRCLE = "user-circle",
	USERREMOVECIRCLE = "user-remove-circle",
	USERS = "users",
	USERSREVERSED = "users-reversed",
	USERSGROUP = "users-group",
	USERLAPTOP = "user-laptop",
	USERVERIFIEDCIRCLE = "user-verified-circle",
	VIDEOADD = "video-add",
	WARNINGCIRCLE = "warning-circle",
	WARNING = "warning",
	WARNINGFILL = "warning-fill",
	WEBSITE = "website",
	WEBSITE2 = "website-2",
	WINDOWPOINTER = "window-pointer",
	WINDOWPRESENTATION = "window-presentation",
	NEWRESEND = "new-resend",
	ZOMENTUM = "zomentum",
	RELOAD = "reload",
	MARKETPLACEINVOICES = "marketplace-invoices",
	MARKETPLACECOMMISSIONS = "marketplace-commissions",
	SUPPLIER = "supplier",
	VENDORHOME = "vendor-home",
	VENDORTEMPLATES = "vendor-templates",
	VENDOROPPORTUNITIES = "vendor-opportunities",
	VENDORRESOURCES = "vendor-resources",
	VENDORPARTNERS = "vendor-partners",
	VENDORSETTINGS = "vendor-settings",
	VENDORCLIENTS = "vendor-clients",
	ELLIPSIS = "ellipsis",
	VENDORPRODUCTS = "vendor-products",
	VENDORTIERS = "vendor-tiers",
	INFOCIRCLEFILLED = "fill-info-circle",
	VIDEOLOADING = "video-loading",
	AUTHENTICATIONSUCCESS = "authentication-success",
	AUTHENTICATIONFAILURE = "authentication-failure",
	GOOGLEMEET = "google-meet",
	MICROSOFTTEAMS = "microsoft-teams",
	ZOOM = "zoom",
	AIWRITER = "ai-writier",
	REPLACE = "replace",
	PAGENUMBER = "page-number",
	PAPERPLANE = "paper-plane",
	MERGETAG = "merge-tag",
	REDIRECT = "redirect",
	RESOURCEPRESENTATION = "resource-presentation",
	RESOURCEPDF = "resource-pdf",
	RESOURCETXT = "resource-txt",
	RESOURCESPREADSHEET = "resource-spreadsheet",
	RESOURCEDOCUMENT = "resource-document",
	RESOURCEVIDEO = "resource-video",
	RESOURCECSV = "resource-csv",
	RESOURCEIMAGE = "resource-image",
	FINANCE = "finance",
	TROPHY = "trophy",
	REVENUE = "revenue",
	TIMER = "timer",
	AIWRITERWHITE = "ai-writier-white",
	CANCELWITHBACKGROUND = "cancel-with-background",
	AIWRITERLOADING = "ai-writer-loading",
	CLOCK = "clock",
	BARCHART = "barchart",
	SETUPFEE = "setup-fee",
	MERGE = "merge",
	INSERTPDF = "insert-pdf",
	INSERTCOVER = "insert-cover",
	TOGGLEWIDTH = "toggle-width",
	INSERTINPUTFIELD = "insert-input-field",
	CONFIGUREMARGIN = "configure-margin",
	INSERTPAGEBREAK = "insert-page-break",
	ESIGNATURE = "e-signature",
	INSERTTEXT = "insert-text",
	TRASHV3 = "trash-v3",
	SAVEV2 = "save-v2",
	REFERENCEBLOCK = "reference-block",
	INSERTQUOTE = "insert-quote",
	SCROLLTOTOP = "scroll-to-top",
	BACKGROUNDCOLORFILL = "background-color-fill"
}

export enum ETwoToneIcons {
	ACTIVESTEP = "active-step",
	ADDONS = "add-ons",
	ADMIN = "admin",
	APIUSER = "api-user",
	ASSIGNEDUSER = "assigned-user",
	BILLING = "billing",
	CALENDAR = "calendar",
	CALENDAR_ORANGE = "calendar-orange",
	CLIENT = "clients",
	COMPLETEDSTEP = "completed-step",
	CONTACT = "contact",
	DISABLEDSTEP = "disabled-step",
	DIVIDE = "divide",
	DOCUMENT = "document",
	DOCUMENTEMAILSETUP = "document-email-setup",
	DOLLAR = "dollar",
	DOWNLOAD = "download",
	EMAILANDCALENDAR = "email-and-calendar",
	EYETWOTONE = "eye-two-tone",
	FOLDERTWOTONE = "folder-two-tone",
	GLOBE = "globe",
	HIGH = "high",
	IMAGE = "image",
	INVISIBLEEYE = "invisible-eye",
	LOCATION = "location",
	LOW = "low",
	MAIL = "mail",
	MAIL_ORANGE = "mail-orange",
	MAILADD = "mail-add",
	MAILNOTIFICATION = "mail-notification",
	MAILSUCCESS = "mail-success",
	MAILTRACKING = "mail-tracking",
	MAILWARNING = "mail-warning",
	MEDIUM = "medium",
	NOTES = "notes",
	NOTES_ORANGE = "notes-orange",
	MANAGER = "manager",
	NOTIFICATION = "notification",
	OPPORTUNITY = "opportunity",
	PACKAGE = "package",
	PARTNERS = "partners",
	PASSWORD = "password",
	PHONE = "phone",
	PHONE_ORANGE = "phone-orange",
	PRIVACY = "privacy",
	SPREADSHEET = "spreadsheet",
	SOFTWARE = "software",
	TASK = "task",
	TASK_ORANGE = "task-orange",
	USER = "user",
	WARNING = "warning",
	GRIDVIEW = "grid-view",
	VIDEOCAMERA = "video-camera",
	SLIDERHORIZONTALACTIVE = "slider-horizontal-active",
	TRANSLATE = "translate",
	RESOURCEPDFTHUMBNAIL = "resource-pdf-thumbnail",
	RESOURCESPREADSHEETTHUMBNAIL = "resource-spreadsheet-thumbnail",
	RESOURCEPRESENTATIONTHUMBNAIL = "resource-presentation-thumbnail",
	RESOURCETXTTHUMBNAIL = "resource-txt-thumbnail",
	RESOURCEDOCTHUMBNAIL = "resource-doc-thumbnail",
	RESOURCEVIDEOTHUMBNAIL = "resource-video-thumbnail",
	RESOURCEIMAGETHUMBNAIL = "resource-image-thumbnail",
	RESOURCECSVTHUMBNAIL = "resource-csv-thumbnail",
	SUCCESSCIRCLE = "success-circle",
	COMPLETEDSTEPOUTLINE = "completed-step-outline",
	ADMINPROFILE = "admin-profile"
}

export enum EIllustrations {
	MICROSOFT = "microsoft",
	AVATAR = "avatar",
	THANKYOUFORMCHECKMARK = "thank-you-form-checkmark",
	EMPTY_NOTIFICATIONS = "empty-notifications",
	MARKETPLACE_ILLUSTRATION = "marketplace-illustration",
	MARKETPLACE_PLACEHOLDER_ICON = "marketplace-placeholder-icon",
	GDPR = "gdpr",
	NO_RESULT_FOUND = "no-result-found",
	HIPAA = "hipaa",
	PCI = "pci",
	ZOMENTUM_GRAY = "zomentum-gray",
	HANDDRAWNCHECK = "hand-drawn-complete-tick",
	PREMIUM_CROWN = "premium-crown",
	IMPORTPRODUCTTOQUOTEHEADER = "import-products-to-quote-header",
	IMPORTPRODUCTTOQUOTEUSINGEXCEL = "import-products-to-quote-using-excel",
	IMPORTPRODUCTTOQUOTEUSINGPDF = "import-products-to-quote-using-pdf",
	NO_RESULT_FOUND_BOX = "no-result-found-box"
}

export const IllustrationDimensions: Record<
	string,
	{ width: number; height: number }
> = {
	[EIllustrations.MICROSOFT]: {
		width: 175,
		height: 84
	},
	[EIllustrations.AVATAR]: {
		width: 32,
		height: 32
	},
	[EIllustrations.THANKYOUFORMCHECKMARK]: {
		width: 281,
		height: 161
	},
	[EIllustrations.EMPTY_NOTIFICATIONS]: {
		width: 157,
		height: 109
	},
	[EIllustrations.MARKETPLACE_ILLUSTRATION]: {
		width: 396,
		height: 120
	},
	[EIllustrations.GDPR]: {
		width: 65,
		height: 20
	},
	[EIllustrations.HIPAA]: {
		width: 65,
		height: 20
	},
	[EIllustrations.PCI]: {
		width: 65,
		height: 20
	},
	[EIllustrations.MARKETPLACE_PLACEHOLDER_ICON]: {
		width: 40,
		height: 40
	},
	[EIllustrations.NO_RESULT_FOUND]: {
		width: 184,
		height: 117
	},
	[EIllustrations.ZOMENTUM_GRAY]: {
		width: 80,
		height: 80
	},
	[EIllustrations.HANDDRAWNCHECK]: {
		width: 84,
		height: 84
	},
	[EIllustrations.PREMIUM_CROWN]: {
		width: 40,
		height: 40
	},
	[EIllustrations.IMPORTPRODUCTTOQUOTEHEADER]: {
		width: 48,
		height: 48
	},
	[EIllustrations.IMPORTPRODUCTTOQUOTEUSINGEXCEL]: {
		width: 40,
		height: 40
	},
	[EIllustrations.IMPORTPRODUCTTOQUOTEUSINGPDF]: {
		width: 40,
		height: 40
	},
	[EIllustrations.NO_RESULT_FOUND_BOX]: {
		width: 185,
		height: 185
	}
};

export enum EVectorIcons {
	PINHUMAN = "pin-human"
}

export enum ESizeMaps {
	xs = 12,
	sm = 16,
	md = 24,
	lg = 32,
	xl = 40,
	xxl = 64
}
